module.exports = __webpack_public_path__ + "static/media/video-1.27a566eb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/video-1.mp4
// module id = 371
// module chunks = 0